
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bang-gia/gia-vang",
      function () {
        return require("private-next-pages/bang-gia/gia-vang/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bang-gia/gia-vang"])
      });
    }
  